import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const createTicket = chatKey =>
  getClient().then(client =>
    client.post(`rooms/${chatKey}/ticket`, { chatKey })
  )
